import emojiDefs from './emojiDefinitions.json';

const vs16RegExp = /\uFE0F/g;
const zeroWidthJoiner = String.fromCharCode(0x200d);
const removeVS16s = rawEmoji => (rawEmoji.indexOf(zeroWidthJoiner) < 0 ? rawEmoji.replace(vs16RegExp, '') : rawEmoji);
const toCodePoints = rawEmoji => {
    const points = [];
    let char = 0;
    let previous = 0;
    let i = 0;
    const unicodeSurrogates = removeVS16s(rawEmoji);
    while (i < unicodeSurrogates.length) {
        char = unicodeSurrogates.charCodeAt(i++);
        if (previous) {
            points.push((0x10000 + ((previous - 0xd800) << 10) + (char - 0xdc00)).toString(16));
            previous = 0;
        } else if (char > 0xd800 && char <= 0xdbff) {
            previous = char;
        } else {
            points.push(char.toString(16));
        }
    }
    return points;
}

export const emojiImageSource = rawEmoji => {
    // return `https://fonts.gstatic.com/s/e/notoemoji/14.0/${toCodePoints(rawEmoji).join('_')}/72.png`;
    // return `https://twemoji.maxcdn.com/v/latest/72x72/${toCodePoints(rawEmoji).join('-')}.png`;
    return `/images/emoji/${toCodePoints(rawEmoji).join('-')}.svg`;
    // return `https://twemoji.maxcdn.com/v/latest/svg/${toCodePoints(rawEmoji).join('-')}.svg`;
}

export const emojiDefinitions = emojiDefs;